(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-item"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__peralbaFaqLd) return;
    window.__peralbaFaqLd = true;

    var mount = function () {
      if (document.querySelector('script[data-faq-page]')) return;

      var items = document.querySelectorAll('[data-faq-question]');
      if (!items.length) return;

      var mainEntity = [];
      for (var i = 0; i < items.length; i += 1) {
        var question = items[i].getAttribute('data-faq-question');
        var answer = items[i].getAttribute('data-faq-answer');
        if (!question || !answer) continue;
        mainEntity.push({
          '@type': 'Question',
          name: question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answer,
          },
        });
      }

      if (!mainEntity.length) return;

      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-faq-page', '');
      script.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: mainEntity,
      });
      document.head.appendChild(script);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount);
    } else {
      mount();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
